


















import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { MerchantId } from "@/helper/userHelper";

const StoreBreadcrumb = namespace("Breadcrumb");

@Component
export default class Breadcrumb extends Vue {
  private path: Array<any> = [];

  @StoreBreadcrumb.Getter
  private getBreadcrumb!: Array<any>;
  private merchantId = MerchantId().PeakEncryption();

  get getPath(): any {
    return this.$route.meta.breadcrumb;
  }

  get route(): any {
    return this.$route;
  }

  @Watch("route", { immediate: true, deep: true })
  routeChanged(newVal: any, oldVal: any) {
    this.SetBreadcrumb();
  }

  @Watch("getBreadcrumb")
  getBreadcrumbChanged(newVal: any, oldVal: any) {
    this.SetBreadcrumb();
  }

  public SetBreadcrumb() {
    this.path.length = 0;
    const path = this.$route.meta.breadcrumb;
    if (path && path.length > 0) {
      path.forEach((item: any) => {
        if (item) {
          this.path.push(item);
        }
      });
    }

    if (this.getBreadcrumb && this.getBreadcrumb.length > 0) {
      this.getBreadcrumb.forEach((item: any) => {
        if (item) {
          this.path.push(item);
        }
      });
    }
  }

  public GetQuery(item: any) {
    const query: any = {
      emi: this.merchantId,
    };

    if (item.query) {
      item.query.forEach((queryItem: any) => {
        query[queryItem.name] = queryItem.value;
      });
    }

    return query;
  }
}
